module.exports = __webpack_public_path__ + "static/media/product-types.a37c4972.png";